import React from "react";
import CarouselSocialProof from "./CarouselSocialProof";
import { SocialProofType } from "../types/SocialProof";
import { CtaButton } from "../Cta/cta-button";

const SocialProof: React.FC<SocialProofType> = ({
  cards,
  ctaLink,
  headline,
  hideCards,
  hideHeader,
  hideLogos,
  logos,
  ctaCopy,
  logosHeadline,
  builderBlock,
  builderBlocksComponent,
  ctaUrl,
  onClick,
}) => {
  return (
    <div className="social--proof redesign-component">
      {!hideHeader && (
        <div className="social--prof__wrapper">
          <div
            className="social--prof__headline"
            dangerouslySetInnerHTML={{ __html: headline }}
          />
          <div className="flex">
            {ctaCopy && (
              <CtaButton
                copy={ctaCopy}
                copySize="bodyRegular"
                isDisabled={false}
                link={ctaLink?.value?.data?.url}
                linkUrl={ctaUrl || null}
                variant="secondaryForest"
                onClick={onClick}
                className="mt-[5px] md:mt-0 no-underline button-no-styling"
              />
            )}
          </div>
        </div>
      )}
      {!hideCards && (
        <div className="social--prof__carousel">
          <CarouselSocialProof
            cards={cards}
            BuilderBlocksComponent={builderBlocksComponent}
            builderBlock={builderBlock}
            onClick={onClick}
          />
        </div>
      )}
      {!hideLogos && (
        <div className="social--prof__partners__wrapper">
          <div
            className={`${
              hideCards
                ? "social--prof__partners--hideCards"
                : "social--prof__partners"
            }`}
          >
            <h2 className="social--prof__partners--title">{logosHeadline}</h2>
          </div>
          <div className="social--prof__partners__logos">
            {logos?.map((item, key) => {
              return (
                <img key={key} src={item?.image} alt={item?.imageAltText} />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialProof;
